import React, { useEffect, useState } from 'react';
import Icon from '../../../../../layouts/common/icons/Icon'
import styles from '../../../../../styles/ToggleButtons.module.css';

const WhatsappToggle = (props) => {
  const [isToggled, setIsToggled] = useState(true);

  useEffect(() => {
    props.getWhatsappToggleStatus(isToggled)
  }, [isToggled])

  const handleToggle = () => {
    setIsToggled(!isToggled);

  };

  return (
    <div className={styles['whatsapp-toggle-cotainer']}>
      <div>
        <Icon iconName={'vm_whatsapp_icon'} className={styles['whatsapp-logo']} style={{marginRight:"8px"}}/>
        <span className={styles.whatsappToggleText}>Send me the updates on whatsapp</span>
      </div>
      <button
        className={`${styles.toggleButton} ${isToggled ? `${styles.toggled} ${styles.toggleButtonActivated}` : ''}`}
        onClick={handleToggle}
      >
      </button>
    </div>
  );
};

export default WhatsappToggle;
